var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"circle"},[_c('div',{staticClass:"triangle-block"},[_c('div',{staticClass:"triangle"})])]),_c('h2',[_vm._v("Your response has been submitted. Thank you for your participation.")])])
}]

export { render, staticRenderFns }